import api from 'apis/api';
import filterApiErr from 'apis/filterApiError';
import { CreateBidRespBody } from 'apis/RespBody';
import { Bid } from 'models/bid/Bid';
import ERR_MSG from 'utils/errorMessage';

export const createBid = async (
  auction_id: string | null,
  price?: number,
  invitation_code?: string,
  dry_run?: boolean
) => {
  if (!auction_id) return Promise.reject({ message: `${ERR_MSG.NOT_FOUND} ${ERR_MSG.BAD_INPUT}` });

  try {
    const resp = await api.post(`/api/v1/bids?dry_run=${dry_run ? '1' : ''}`, { auction_id, price, invitation_code });
    const data = resp.data as CreateBidRespBody;
    return Promise.resolve(data);
  } catch (_err: any) {
    const err = filterApiErr(_err);
    if (err && !err.response.data.message) {
      err.response.data.message = `${ERR_MSG.UNKNOWN} ${ERR_MSG.REPORT}`;
    }

    return Promise.reject(err?.response.data);
  }
};

export const fetchBids = async (auctionId: string) => {
  try {
    const resp = await api.get(`/api/v1/bids?auction_id=${auctionId}`);
    const data = resp.data.bids as Bid[];
    return Promise.resolve(data);
  } catch (_err: any) {
    let errMsg = '';

    const err = filterApiErr(_err);
    if (err) {
      errMsg = `${ERR_MSG.UNKNOWN} ${ERR_MSG.REPORT}`;
    }

    return Promise.reject(errMsg);
  }
};
